export default "__VITE_ASSET__e8810ad8__"